import { useQuery } from "@tanstack/react-query";
import { WiMuleSQL } from "../../services/WiMuleSQL";

export const useGetFilterList = (location, faultInfo) => {
  const fetchData = async () => {
    const encodedLocation = encodeURIComponent(location || "%");
    const encodedFaultInfo = encodeURIComponent(faultInfo || "%");

    const queryString = `${WiMuleSQL}/api/ActiveFaults/GetFilterList?location=${encodedLocation}&faultInfo=${encodedFaultInfo}`;
    console.log("FilterListQueried", queryString);

    const response = await fetch(queryString, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP Error: ${response.status}`);
    }

    const data = await response.json();
    return data.data;
  };

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["getFilterList", location, faultInfo],
    queryFn: fetchData,
    enabled: !!location || !!faultInfo,
  });

  return { data, isLoading, isError, error };
};
